import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { colors, ApMenu } from '@alixpartners/ui-components';

export const StyledMenu = styled(ApMenu)`
	padding-bottom: 0 !important;
	overflow: hidden !important;
	display: flex;
	flex-direction: column;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	max-height: 100%;
	overflow: hidden;
`;

export const DropdownLabel = styled.button`
	max-width: 100%;
	height: 38px;
	border: none;
	font-weight: 500;
	font-size: 13px;
	letter-spacing: 0.3px;
	text-transform: uppercase;
	color: ${colors.grey8};
	border: 1px solid transparent;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 4px 0 4px 9px;
	background-color: ${colors.white};
	outline: none;

	&:hover {
		background-color: ${rgba(colors.green2, 0.1)};
	}

	&:focus {
		background-color: ${rgba(colors.green2, 0.2)};
	}

	&:active {
		background-color: ${rgba(colors.green2, 0.3)};
		border: 1px solid ${colors.green3};
	}

	${({ isOpen }) =>
		isOpen
			? css`
					border: 1px solid ${colors.green3};

					svg:last-child {
						transform: rotate(180deg);
					}
			  `
			: ''};

	${({ disabled }) =>
		disabled
			? css`
					pointer-events: none;
					background-color: none;
					color: ${colors.grey5};
			  `
			: css`
					cursor: pointer;
			  `};
`;

export const LabelText = styled.span`
	color: ${({ disabled }) =>
		disabled ? `${colors.grey5}` : `${colors.grey8}`};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 13px;
	letter-spacing: 0.3px;
	line-height: 38px;
	padding: 2px 0 0 4px;
`;

export const List = styled.div`
	display: flex;
	flex-direction: column;
	padding-top: 8px;
	overflow: auto;
`;

export const ListItem = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	padding: 0 24px 0 12px;
	height: 40px;
	min-height: 40px;
`;

export const ListInfo = styled.div`
	font-size: 13px;
	color: ${colors.grey5};
	margin-left: auto;
	letter-spacing: 0.3px;
	padding-left: 24px;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;

export const Footer = styled.div`
	display: flex;
	border-top: 1px solid ${colors.grey3};
	padding: 6px 8px;
	justify-content: space-between;
`;

export const CheckboxLabel = styled.div`
	font-size: 16px;
	color: ${colors.grey8};
	letter-spacing: 0.3px;
`;
